import { render } from "./NftViewer.vue?vue&type=template&id=12a84979"
import script from "./NftViewer.vue?vue&type=script&lang=ts"
export * from "./NftViewer.vue?vue&type=script&lang=ts"
script.render = render

export default script